import { SET_IS_DELIVERY_PASS_ACTIVE } from 'redux/modules/slot-booking/actions/types';

export const setIsDeliveryPassActive = (isActive: boolean) => ({
  type: SET_IS_DELIVERY_PASS_ACTIVE,
  isActive,
});
